module.exports = __webpack_public_path__ + "8a5356e9/img/document.e2130c6b.svg";